import { useContext } from "react";
import { AuthContext } from "./context/authContext/AuthContext";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Home from './pages/home/Home';
import Agence from './pages/agence/Agence';
import Notification from './pages/notification/Notification';
import Register from './pages/register/Register';
import Login from './pages/login/Login';
import Entreprise from "./pages/entreprise/Entreprise";
import Delivery from "./pages/delivery/Delivery";
import Client from "./pages/client/Client";
import Agent from "./pages/agent/Agent";
import UpdateEnvoie from "./pages/envoie/UpdateEnvoie";
import DetailEnvoie from "./pages/envoie/DetailEnvoie";
import Envoie from "./pages/envoie/Envoie";
import Bagage from "./pages/action/Bagage";
import Cost from "./pages/cost/Cost";
import TrackingEnvoie from "./pages/envoie/TrackingEnvoie";
import Action from "./pages/action/Action";
import Movement from "./pages/movement/Movement";
import Invoice from "./pages/invoice/Invoice";
import CreateInvoice from "./pages/invoice/CreateInvoice";
import DetailInvoice from "./pages/invoice/DetailInvoice";
import Decharge from "./pages/movement/Decharge";
import DetailDecharge from "./pages/movement/DetailDecharge";
import SettingDetail from "./pages/setting/SettingDetail";
import Infoperson from "./pages/infoperson/Infoperson";
import CreateAction from "./pages/action/CreateAction";
import DetailEncaissement from "./pages/movement/DetailEncaissement";
import DechargeRetourAutre from "./pages/movement/DechargeRetourAutre";
import DetailDechargeRetourAutre from "./pages/movement/DetailDechargeRetourAutre";
import CreateEnvoie from "./pages/envoie/CreateEnvoie";

function App() {
  const { user } = useContext(AuthContext);


  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={
          user ? <Home /> : <Navigate to='/login' />
        } />

        {/* Envois Part */}
        <Route path="/envois/ajouter" element={
          user ? <CreateEnvoie /> : <Navigate to={'/login'} />
        } />
        <Route path="/envois/update/:id" element={
          user ? <UpdateEnvoie /> : <Navigate to={'/login'} />
        } />
        <Route path="/envois/detail/:id/tracking" element={
          user ? <TrackingEnvoie /> : <Navigate to={'/login'} />
        } />
        <Route path="/envois/detail/:id" element={
          user ? <DetailEnvoie /> : <Navigate to={'/login'} />
        } />
        <Route path="/envois/:page" element={
          user ? <Envoie /> : <Navigate to={'/login'} />
        } />
        <Route path="/envois" element={
          user ? <Envoie /> : <Navigate to={'/login'} />
        } />


        {/* Cart Part */}
        {/* <Route path="/cart/:page" element={
          user ? <Cart /> : <Navigate to='/login' />
        } />
        <Route path="/cart" element={
          user ? <Cart /> : <Navigate to='/login' />
        } /> */}


        {/* Notifications Part */}
        <Route path="/notifications" element={
          user ? <Notification /> : <Navigate to='/login' />
        } />


        {/* Agences Part */}
        <Route path="/agences" element={
          user ? <Agence /> : <Navigate to='/login' />
        } />
        <Route path="/agences/:page" element={
          user ? <Agence /> : <Navigate to='/login' />
        } />


        {/* Entreprises Part */}
        <Route path="/entreprises" element={
          user ? <Entreprise /> : <Navigate to='/login' />
        } />
        <Route path="/entreprises/:page" element={
          user ? <Entreprise /> : <Navigate to='/login' />
        } />


        {/* Deliveries Part */}
        <Route path="/deliveries" element={
          user ? <Delivery /> : <Navigate to='/login' />
        } />
        <Route path="/deliveries/:page" element={
          user ? <Delivery /> : <Navigate to='/login' />
        } />


        {/* Clients Part */}
        <Route path="/clients" element={
          user ? <Client /> : <Navigate to='/login' />
        } />
        <Route path="/clients/:page" element={
          user ? <Client /> : <Navigate to='/login' />
        } />

         {/* Agent Part */}
         <Route path="/agents" element={
          user ? <Agent /> : <Navigate to='/login' />
        } />
        <Route path="/agents/:page" element={
          user ? <Agent /> : <Navigate to='/login' />
        } />


        {/* Movements Part */}
        <Route path="/movements" element={
          user ? <Movement /> : <Navigate to='/login' />
        } />
        <Route path="/movements/dechargeretourautre" element={
          user ? <DechargeRetourAutre /> : <Navigate to='/login' />
        } />
        <Route path="/movements/dechargeretourautre/:id/detail" element={
          user ? <DetailDechargeRetourAutre /> : <Navigate to='/login' />
        } />
        <Route path="/movements/decharge" element={
          user ? <Decharge /> : <Navigate to='/login' />
        } />
        <Route path="/movements/decharge/:page" element={
          user ? <Decharge /> : <Navigate to='/login' />
        } />
        <Route path="/movements/decharge/:id/detail" element={
          user ? <DetailDecharge /> : <Navigate to='/login' />
        } />
        <Route path="/movements/decharge/:id/detail/:page" element={
          user ? <DetailDecharge /> : <Navigate to='/login' />
        } />
        <Route path="/movements/encaisse/:id/detail" element={
          user ? <DetailEncaissement /> : <Navigate to='/login' />
        } />
        <Route path="/movements/encaisse/:id/detail/:page" element={
          user ? <DetailEncaissement /> : <Navigate to='/login' />
        } />
        <Route path="/movements/:page" element={
          user ? <Movement /> : <Navigate to='/login' />
        } />

        {/* Invoices Part */}
        <Route path="/invoices/create" element={
          user ? <CreateInvoice /> : <Navigate to='/login' />
        } />
        <Route path="/invoices/create/:page" element={
          user ? <CreateInvoice /> : <Navigate to='/login' />
        } />
        <Route path="/invoices/:id/detail" element={
          user ? <DetailInvoice /> : <Navigate to='/login' />
        } />
        <Route path="/invoices/:id/detail/:page" element={
          user ? <DetailInvoice /> : <Navigate to='/login' />
        } />
        <Route path="/invoices/:page" element={
          user ? <Invoice /> : <Navigate to='/login' />
        } />
        <Route path="/invoices" element={
          user ? <Invoice /> : <Navigate to='/login' />
        } />


        {/* Actions Part */}
        <Route path="/actions" element={
          user ? <Action /> : <Navigate to='/login' />
        } />
        <Route path="/actions/create" element={
          user ? <CreateAction /> : <Navigate to='/login' />
        } />
        <Route path="/actions/create/:page" element={
          user ? <CreateAction /> : <Navigate to='/login' />
        } />
        <Route path="/actions/:id/bagages" element={
          user ? <Bagage /> : <Navigate to='/login' />
        } />
        <Route path="/actions/:id/bagages/:page" element={
          user ? <Bagage /> : <Navigate to='/login' />
        } />
        <Route path="/actions/:page" element={
          user ? <Action /> : <Navigate to='/login' />
        } />


        {/* Costs Part */}
        <Route path="/costs" element={
          user ? <Cost /> : <Navigate to='/login' />
        } />

        {/* Settings Part */}
        <Route path="/settings" element={
          user ? <SettingDetail /> : <Navigate to='/login' />
        } />

        {/* Infos Person Part */}
        <Route path="/infoperson" element={
          user ? <Infoperson /> : <Navigate to='/login' />
        } />


        {/*  Auth Routes  */}
        <Route path="/login" element={
          user ? <Navigate replace to='/' /> : <Login />
        } />
        <Route path="/register" element={
          user ? <Navigate replace to="/" /> : <Register />
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
